export default {
  // list
  'job.query.jobName': '任务名称',
  'job.query.jobName.placeholder': '请输入任务名称',
  'job.column.jobName': '任务名称',
  'job.column.jobGroup': '任务分组',
  'job.column.cron': 'cron',
  'job.column.invokeClassName': '执行类',
  'job.column.methodName': '执行方法',
  'job.column.status': '状态',
  'job.column.operation.exec': '立即执行',
  'job.column.operation.log': '日志',
  'job.message.delete.batch.confirm': '确认要删除选中的{length}条记录吗？',
  'job.message.delete.confirm': '确认要删除"{jobName}"吗？',
  'job.message.exec.confirm': '确认要立即执行吗？',
  'job.message.status.confirm': '确认要{status}"{jobName}"吗？',
  'job.message.exec.success': '执行成功',
  // edit
  'job.edit.title': '修改任务',
  'job.add.title': '新增任务',
  'job.edit.success': '修改成功',
  'job.add.success': '新增成功',
  'job.edit.form.jobName': '任务名称',
  'job.edit.form.jobName.placeholder': '请输入任务名称',
  'job.edit.form.jobName.required': '请输入任务名称',
  'job.edit.form.jobGroup': '任务分组',
  'job.edit.form.jobGroup.placeholder': '请输入任务分组',
  'job.edit.form.jobGroup.required': '请输入任务分组',
  'job.edit.form.cron': 'cron表达式',
  'job.edit.form.cron.placeholder': '请输入cron表达式',
  'job.edit.form.cron.required': '请输入cron表达式',
  'job.edit.form.status': '任务状态',
  'job.edit.form.status.placeholder': '请选择任务状态',
  'job.edit.form.status.required': '请选择任务状态',
  'job.edit.form.status.normal': '运行中',
  'job.edit.form.status.stopped': '已停止',
  'job.edit.form.invokeMode': '执行方式',
  'job.edit.form.invokeMode.placeholder': '请选择执行方式',
  'job.edit.form.invokeMode.required': '请选择执行方式',
  'job.edit.form.springBeanName': 'SpringBean',
  'job.edit.form.springBeanName.placeholder': '请输入任务执行类的SpringBean名',
  'job.edit.form.springBeanName.required': '请输入任务执行类的SpringBean名',
  'job.edit.form.invokeClassName': 'Class',
  'job.edit.form.invokeClassName.placeholder': '请输入任务执行类的全类名',
  'job.edit.form.invokeClassName.required': '请输入任务执行类的全类名',
  'job.edit.form.methodName': '执行方法',
  'job.edit.form.methodName.placeholder': '请输入任务执行的方法名',
  'job.edit.form.methodName.required': '请输入任务执行的方法名',
  'job.edit.form.methodParams': '方法参数',
  'job.edit.form.methodParams.placeholder': '请输入任务执行方法参数(选填)',
  'job.edit.form.misfirePolicy': '执行策略',
  'job.edit.form.misfirePolicy.placeholder': '请选择执行策略',
  'job.edit.form.misfirePolicy.required': '请选择执行策略',
  'job.edit.form.misfirePolicy.default': '默认',
  'job.edit.form.misfirePolicy.fireNow': '立即触发执行',
  'job.edit.form.misfirePolicy.fireOnce': '触发一次执行',
  'job.edit.form.misfirePolicy.ignore': '不触发立即执行',
  'job.edit.form.alarmEmail': '告警邮箱',
  'job.edit.form.alarmEmail.placeholder': '请输入任务失败后的告警邮箱(选填)',
  'job.edit.form.concurrent': '允许并发',
  'job.edit.form.concurrent.placeholder': '请选择允许并发',
  'job.edit.form.concurrent.required': '请选择允许并发',
  'job.edit.form.pauseAfterFailure': '失败后暂停',
  'job.edit.form.pauseAfterFailure.placeholder': '请选择失败后暂停',
  'job.edit.form.pauseAfterFailure.required': '请选择失败后暂停',
  // log
  'job.log.title': '执行日志',
  'job.log.query.execTime': '执行时间',
  'job.log.query.startTime.placeholder': '选择开始时间',
  'job.log.query.endTime.placeholder': '选择结束时间',
  'job.log.column.jobName': '任务名称',
  'job.log.column.invokeClassName': '执行类',
  'job.log.column.methodName': '执行方法',
  'job.log.column.success': '执行结果',
  'job.log.column.success.true': '成功',
  'job.log.column.success.false': '失败',
  'job.log.column.startTime': '执行时间',
  'job.log.column.execTime': '执行时长',
  'job.log.column.endTime': '结束时间',
  'job.log.message.delete.confirm': '确认要删除"{id}"吗？',
  'job.log.pickerOptions.shortcuts.today': '今天',
  'job.log.pickerOptions.shortcuts.yesterday': '昨天',
  'job.log.pickerOptions.shortcuts.lastWeek': '一周前',
}
